import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import AwardsPage from './pages/AwardsPage';
import BlogsPage from './pages/BlogsPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import WhatsappButton from './components/WhatsappButton';
import { HomePageProvider } from './context/HomePageContext';

function App() {
  return (
    <Router>
      <HomePageProvider>
        <Layout>
          {() => (
            <>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/awards" element={<AwardsPage />} />
                <Route path="/blog" element={<BlogsPage />} />
                <Route path="/blog/:id" element={<BlogDetailPage />} />
                <Route path="/contact-us" element={<ContactPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:id" element={<ServiceDetailPage />} />
              </Routes>
              <WhatsappButton />
            </>
          )}
        </Layout>
      </HomePageProvider>
    </Router>
  );
}

export default App;
